import React from 'react';
import { ShieldCheckIcon, AlertTriangleIcon, DownloadIcon, UsersIcon, CheckCircleIcon, ListChecksIcon, SparklesIcon, FileSearchIcon } from 'lucide-react';
import { ScreenProps } from '../../types/ptp';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SecondaryButton } from '../ui/SecondaryButton';
export function Screen16_UpdatedPTP({
  data,
  onNext,
  onBack,
  onExport
}: ScreenProps) {
  return <div className="flex flex-col h-full" data-id="element-665">
      <div className="flex items-center gap-3 mb-4" data-id="element-666">
        <ShieldCheckIcon className="w-8 h-8 text-yellow-500" data-id="element-667" />
        <h2 className="text-2xl font-bold text-white leading-tight" data-id="element-668">
          PTP Updated from Meeting
        </h2>
      </div>

      <div className="inline-flex items-center gap-2 bg-yellow-500/20 text-yellow-400 px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-6 self-start" data-id="element-669">
        <SparklesIcon className="w-4 h-4" data-id="element-670" />
        Updated by AI Review
      </div>

      <div className="flex-1 overflow-y-auto pb-6 -mx-4 px-4 space-y-6" data-id="element-671">
        <div className="bg-slate-900 border border-slate-800 rounded-xl p-5 space-y-3" data-id="element-672">
          <div className="grid grid-cols-2 gap-4" data-id="element-673">
            <div data-id="element-674">
              <p className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-1" data-id="element-675">
                Project
              </p>
              <p className="text-white font-medium text-sm" data-id="element-676">{data.project}</p>
            </div>
            <div data-id="element-677">
              <p className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-1" data-id="element-678">
                Location
              </p>
              <p className="text-white font-medium text-sm" data-id="element-679">{data.location}</p>
            </div>
          </div>
          <div className="pt-3 border-t border-slate-800" data-id="element-680">
            <p className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-1" data-id="element-681">
              Task
            </p>
            <p className="text-yellow-400 font-bold text-sm" data-id="element-682">
              Steel Beam Installation Using Mobile Crane
            </p>
          </div>
        </div>

        <section data-id="element-683">
          <div className="flex items-center gap-2 mb-3" data-id="element-684">
            <ListChecksIcon className="w-5 h-5 text-slate-400" data-id="element-685" />
            <h3 className="text-sm font-bold text-white uppercase tracking-wider" data-id="element-686">
              Job Steps — Hazards & Controls
            </h3>
          </div>
          <div className="space-y-3" data-id="element-687">
            {data.steps.map((step, i) => <div key={i} className="bg-slate-900 border border-slate-800 rounded-xl overflow-hidden" data-id="element-688">
                <div className="px-4 py-3 border-b border-slate-800 flex gap-3" data-id="element-689">
                  <span className="text-yellow-500 font-bold text-sm flex-shrink-0" data-id="element-690">
                    {i + 1}.
                  </span>
                  <span className="text-white font-medium text-sm" data-id="element-691">
                    {step.description}
                  </span>
                </div>
                <div className="px-4 py-3 space-y-3" data-id="element-692">
                  {step.hazards.map((h, j) => <div key={j} className="space-y-2" data-id="element-693">
                      <div className="flex items-start gap-2" data-id="element-694">
                        <AlertTriangleIcon className={`w-3.5 h-3.5 mt-0.5 flex-shrink-0 ${h.isNew ? 'text-yellow-400' : 'text-red-400'}`} data-id="element-695" />
                        <div className="flex-1 flex items-center gap-2 flex-wrap" data-id="element-696">
                          <span className={`text-xs ${h.isNew ? 'text-yellow-300 font-medium' : 'text-red-200'}`} data-id="element-697">
                            {h.hazard}
                          </span>
                          {h.riskLevel && <span className={`text-[9px] font-bold px-1.5 py-0.5 rounded ${h.riskLevel === 'HIGH' ? 'bg-red-500/20 text-red-400' : h.riskLevel === 'MEDIUM' ? 'bg-amber-500/20 text-amber-400' : 'bg-green-500/20 text-green-400'}`} data-id="element-698">
                              {h.riskLevel}
                            </span>}
                          {h.isNew && <span className="text-[9px] uppercase bg-yellow-500/20 text-yellow-400 px-1.5 py-0.5 rounded font-bold" data-id="element-699">
                              New
                            </span>}
                        </div>
                      </div>
                      <div className="ml-5 space-y-1" data-id="element-700">
                        {h.controls.map((c, k) => <div key={k} className="flex items-start gap-2 text-xs" data-id="element-701">
                            <CheckCircleIcon className="w-3 h-3 text-green-500 mt-0.5 flex-shrink-0" data-id="element-702" />
                            <span className="text-green-100" data-id="element-703">{c}</span>
                          </div>)}
                      </div>
                    </div>)}
                </div>
              </div>)}
          </div>
        </section>

        <section data-id="element-704">
          <div className="flex items-center gap-2 mb-3" data-id="element-705">
            <UsersIcon className="w-5 h-5 text-slate-400" data-id="element-706" />
            <h3 className="text-sm font-bold text-white uppercase tracking-wider" data-id="element-707">
              Crew
            </h3>
          </div>
          <div className="flex flex-wrap gap-2" data-id="element-708">
            {data.crewRoles.map((role, i) => <div key={i} className="bg-slate-800 border border-slate-700 text-slate-300 px-3 py-1.5 rounded-md text-sm font-medium" data-id="element-709">
                {role.role}
              </div>)}
          </div>
        </section>

        <section data-id="element-710">
          <div className="flex items-center gap-2 mb-3" data-id="element-711">
            <ShieldCheckIcon className="w-5 h-5 text-green-400" data-id="element-712" />
            <h3 className="text-sm font-bold text-white uppercase tracking-wider" data-id="element-713">
              Required PPE
            </h3>
          </div>
          <div className="flex flex-wrap gap-2" data-id="element-714">
            {data.ppeControls.map((ppe, i) => <div key={i} className="bg-green-950/20 border border-green-900/30 text-green-100 px-3 py-1.5 rounded-md text-sm font-medium" data-id="element-715">
                {ppe}
              </div>)}
          </div>
        </section>

        <section data-id="element-716">
          <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-3" data-id="element-717">
            Equipment
          </h3>
          <div className="flex flex-wrap gap-2" data-id="element-718">
            {data.equipment.map((item, i) => <div key={i} className="bg-slate-800 border border-slate-700 text-slate-300 px-3 py-1.5 rounded-md text-sm font-medium" data-id="element-719">
                {item}
              </div>)}
          </div>
        </section>

        <section data-id="element-720">
          <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-3" data-id="element-721">
            Pre-Work Safety Checks
          </h3>
          <div className="bg-slate-900 border border-slate-800 rounded-xl p-4 space-y-2" data-id="element-722">
            {data.safetyChecks.map((check, i) => <div key={i} className="flex items-center gap-2 text-slate-300 text-sm" data-id="element-723">
                <CheckCircleIcon className="w-4 h-4 text-green-500" data-id="element-724" />
                {check}
              </div>)}
          </div>
        </section>

        <section data-id="element-725">
          <div className="flex items-center gap-2 mb-3" data-id="element-726">
            <SparklesIcon className="w-5 h-5 text-yellow-500" data-id="element-727" />
            <h3 className="text-sm font-bold text-white uppercase tracking-wider" data-id="element-728">
              AI Meeting Notes
            </h3>
          </div>
          <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-xl p-4 space-y-2" data-id="element-729">
            <p className="text-sm text-yellow-200" data-id="element-730">
              <span className="font-bold text-white" data-id="element-731">Meeting Score:</span>{' '}
              {data.meetingScore || 72} / 100
            </p>
            <p className="text-sm text-yellow-200" data-id="element-732">
              <span className="font-bold text-white" data-id="element-733">Main Gap:</span> crew
              participation and missing review of wind and emergency response
            </p>
          </div>
        </section>
      </div>

      <div className="pt-4 space-y-3 bg-slate-950" data-id="element-734">
        <PrimaryButton onClick={onNext} data-id="element-735">Continue to Quiz</PrimaryButton>
        <div className="flex gap-2" data-id="element-736">
          <SecondaryButton onClick={() => onExport?.()} icon={<DownloadIcon className="w-5 h-5" data-id="element-738" />} className="flex-1" data-id="element-737">
            Export PTP
          </SecondaryButton>
          <SecondaryButton onClick={onBack} icon={<FileSearchIcon className="w-5 h-5" data-id="element-740" />} className="flex-1" data-id="element-739">
            Meeting Review
          </SecondaryButton>
        </div>
      </div>
    </div>;
}